import React from 'react';
import { Table } from 'react-bootstrap'
import PropTypes from 'prop-types';

import { redirectTo, jobPath } from "helpers/PathHelpers";
import { FaIcon } from "shared/fa-icon"
import { addressToString } from 'actions/addresses';
import { selectOptionOrOther } from "helpers/ViewHelpers";
import Spinner from 'shared/spinner';
import { Pagination } from "shared/pagination";
import { Sorting } from "shared/sorting";
import {
  CALLBACK, JOB, CLIENT_NAME, ROOF_TYPE, BUILDING_TYPE,
  ADDRESS, CREATED_AT, ESTIMATOR, TYPE, STATUS
} from "helpers/AppConstants";

class JobsTable extends React.Component {
  constructor(props) {
    super(props);
    this.renderRow = this.renderRow.bind(this);
    this.renderSortComponent = this.renderSortComponent.bind(this)
  }
  renderRow(job) {
    const { loadJobToEditForm } = this.props;
    return (
      <tr key={job.id} className="pointer-cursor">
        <td onClick={() => redirectTo(jobPath(job.id))}>{ job.client && job.client.name }</td>
        <td onClick={() => redirectTo(jobPath(job.id))}>{ selectOptionOrOther('roof_type', job) }</td>
        <td onClick={() => redirectTo(jobPath(job.id))}>{ selectOptionOrOther('building_type', job) }</td>
        <td onClick={() => redirectTo(jobPath(job.id))}>{ addressToString(job.address) }</td>
        <td onClick={() => redirectTo(jobPath(job.id))}>{ job.created_at }</td>
        <td onClick={() => redirectTo(jobPath(job.id))}>{ job.user && job.user.name }</td>
        <td onClick={() => redirectTo(jobPath(job.id))}>{ job.callback ? CALLBACK : JOB }</td>
        <td onClick={() => redirectTo(jobPath(job.id))}>{ job.status }</td>
        <td>
          <a onClick={() => loadJobToEditForm(job)} className="text-muted"><FaIcon icon="pencil"/></a>
        </td>
      </tr>
    )
  }

  renderBody(jobs) {
    return (
      jobs.map((job)=> this.renderRow(job))
    )
  }

  renderSortComponent(title, sortBy) {
    const { onTableSort, search } = this.props;
    return(
      <Sorting
        title={title}
        onClick={onTableSort}
        sortBy={sortBy}
        orderBy={search.sort.orderBy}
        selectedSortKey={search.sort.sortBy}
      />
    )
  }

  render() {
    const { jobs, onPageChange } = this.props;
    return (
      <div>
        <Table striped bordered condensed hover>
          <thead>
          <tr>
            <th className="col-md-2">{this.renderSortComponent("Client's name", CLIENT_NAME)}</th>
            <th className="col-md-2">{this.renderSortComponent("Roof type", ROOF_TYPE)}</th>
            <th className="col-md-2">{this.renderSortComponent("Building type", BUILDING_TYPE)}</th>
            <th className="col-md-3">{this.renderSortComponent("Address", ADDRESS)}</th>
            <th className="col-md-2">{this.renderSortComponent("Date called in", CREATED_AT)}</th>
            <th className="col-md-2">{this.renderSortComponent("Estimator", ESTIMATOR)}</th>
            <th className="col-md-2">{this.renderSortComponent("Type", TYPE)}</th>
            <th className="col-md-2">{this.renderSortComponent("Status", STATUS)}</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          {!jobs.loading && this.renderBody(jobs.list)}
          </tbody>
        </Table>
        <Spinner active={jobs.loading} search><span>Loading...</span></Spinner>
        <Pagination hide={jobs.loading} paginationData={jobs.meta} onPageChange={onPageChange} />
      </div>
    )
  }
}

JobsTable.propTypes = {
  onPageChange: PropTypes.func.isRequired,
  onTableSort: PropTypes.func.isRequired,
  loadJobToEditForm: PropTypes.func.isRequired,
  jobs: PropTypes.object.isRequired,
  search: PropTypes.object.isRequired
};

export default JobsTable
